// ConsentFormBody.jsx
// Pure presentational markup for the SMS consent form -- fields, checkbox
// copy, Privacy Policy link, and Submit button. Used by the real
// ConsentForm.jsx (MSAL-gated, live data capture).
//
// Previously also shared by a React ConsentPreview.jsx route at
// /consent-preview, retired in favor of a plain static HTML page
// (legal/consent-preview.html, served directly by nginx like /privacy and
// /terms) so a JS-less fetch sees real content instead of an empty
// <div id="root">. legal/consent-preview.html is hand-maintained to match
// this component's copy -- there's no shared source between them anymore,
// so a future change here needs a matching edit there. See CHAT_CONTEXT.md.

export const CONSENT_CHECKBOX_TEXT =
  "I agree to receive SMS notifications from TCC TrapperKeeper for task and project alerts. Message frequency varies. Message and data rates may apply. Reply STOP to opt out.";

export default function ConsentFormBody({
  name, setName, email, setEmail, phone, setPhone,
  agreed, setAgreed, onSubmit, submitDisabled, submitLabel, statusNode,
}) {
  return (
    <div style={{ maxWidth: 480, padding: 20 }}>
      <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 12, color: "#1a1a2e" }}>SMS Notification Consent</div>
      <div style={{ background: "#f0f9ff", border: "1px solid #bae6fd", borderRadius: 6, padding: "8px 12px", marginBottom: 14, fontSize: 11, color: "#0369a1" }}>
        SMS is optional. You'll still receive project updates by email and Microsoft Teams even if you don't opt in here.
      </div>
      <form onSubmit={onSubmit}>
        <div style={{ marginBottom: 10 }}>
          <div style={{ fontSize: 11, color: "#6b7280", marginBottom: 3 }}>Name</div>
          <input value={name} onChange={function (e) { setName(e.target.value); }} style={{ width: "100%", padding: "6px 8px", border: "1px solid #e5e7eb", borderRadius: 4, boxSizing: "border-box" }} />
        </div>
        <div style={{ marginBottom: 10 }}>
          <div style={{ fontSize: 11, color: "#6b7280", marginBottom: 3 }}>Email</div>
          <input value={email} onChange={function (e) { setEmail(e.target.value); }} style={{ width: "100%", padding: "6px 8px", border: "1px solid #e5e7eb", borderRadius: 4, boxSizing: "border-box" }} />
        </div>
        <div style={{ marginBottom: 10 }}>
          <div style={{ fontSize: 11, color: "#6b7280", marginBottom: 3 }}>Phone number</div>
          <input value={phone} onChange={function (e) { setPhone(e.target.value); }} placeholder="+1..." style={{ width: "100%", padding: "6px 8px", border: "1px solid #e5e7eb", borderRadius: 4, boxSizing: "border-box" }} />
        </div>
        <label style={{ display: "flex", alignItems: "flex-start", gap: 8, marginBottom: 6, fontSize: 12, color: "#374151" }}>
          <input type="checkbox" checked={agreed} onChange={function (e) { setAgreed(e.target.checked); }} style={{ marginTop: 2 }} />
          <span>{CONSENT_CHECKBOX_TEXT}</span>
        </label>
        <div style={{ marginBottom: 14, marginLeft: 24, fontSize: 11, color: "#6b7280" }}>
          See our <a href="https://tk.tripleco.com/privacy" target="_blank" rel="noopener noreferrer" style={{ color: "#6b7280" }}>Privacy Policy</a> and <a href="https://tk.tripleco.com/terms" target="_blank" rel="noopener noreferrer" style={{ color: "#6b7280" }}>Terms and Conditions</a>.
        </div>
        <button type="submit" disabled={submitDisabled}
          style={{ padding: "8px 16px", background: "#1a1a2e", color: "#c9a84c", border: "none", borderRadius: 6, cursor: "pointer", fontWeight: 700 }}>
          {submitLabel}
        </button>
        {statusNode}
      </form>
    </div>
  );
}
